import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('CURRENTUSER_TOGGLEBIGPLAN').plugin(axiosPlugin);

let updateAction = redux.fetchActionUpdate();

export const updateCurrentUserToggleBigPlan = (data = {}) => updateAction(`/users/me/set-toggle-big-plan`, data);
export const resetCurrentUserToggleBigPlan = () => redux.actions.reset();

export const currentUserToggleBigPlan = redux.reducer();